var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-bids d-flex align-center justify-center"},[_c('div',{staticClass:"text-center"},[_c('v-img',{staticClass:"mb-6 mx-auto",attrs:{"src":require("@/assets/img/docs.png"),"width":"72px"}}),_c('h3',{staticClass:"font font--h3 mb-2"},[_vm._v("У вас нет доступа для просмотра заявок")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }